import { useEffect } from "react";
import { useDrag } from "react-dnd";
import { setDragging } from "./dragDrop";
import { UserCard } from "./UserCard";

export function DraggableCard({ user, container }) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "OrderCard",
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  useEffect(() => {
    if (isDragging) {
      setDragging({user, container});
    }
  }, [isDragging, user, container]);

  return (
    <div style={{ position: "relative" }}>
      <div
        ref={drag}
        style={{
          opacity: isDragging ? 0.5 : 1,
          cursor: "move",
        }}
      >
        <UserCard user={user} />
      </div>
    </div>
  );
}
